"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PurchaseCommand = void 0;
const AbstractCommand_1 = require("./AbstractCommand");
class PurchaseCommand extends AbstractCommand_1.AbstractCommand {
    constructor(input) {
        super(input);
        this.input = input;
    }
    async execute(config) {
        return this.getCommandService(config).doTrackPurchaseEvent(this.input);
    }
}
exports.PurchaseCommand = PurchaseCommand;
